import gitInfo from "../data/gitInfo.json";

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const yearText = currentYear > 2022 ? `2022–${currentYear}` : "2022";

  return (
    <footer id="footer">
      <span>The Unlicensed</span>
      <span className="footer-sep">&bull;</span>
      <span>&copy; charliegp {yearText}</span>
      <span className="footer-sep">&bull;</span>
      <span className="footer-build">build {gitInfo.commit}</span>
      <span className="footer-sep">&bull;</span>
      <span>
        Hosted by{" "}
        <a href="https://www.vercel.com" className="footer-link">Vercel</a>
      </span>
    </footer>
  );
}